export const LANDING = '/'
export const SWAP = '/swap'
export const ABOUT = '/about'
export const EXCHANGE = '/exchange'
export const ORDERS = '/orders'
export const POINTS = '/miles'
export const STATS = '/stats'
export const DOCS = 'https://docs.mach.exchange'
export const DEVS = 'https://www.mach.exchange/developers'
export const APP = 'https://app.mach.exchange'
